import { render, staticRenderFns } from "./CompletedTab.vue?vue&type=template&id=59f72d6e&scoped=true"
import script from "./CompletedTab.vue?vue&type=script&lang=js"
export * from "./CompletedTab.vue?vue&type=script&lang=js"
import style0 from "./CompletedTab.vue?vue&type=style&index=0&id=59f72d6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f72d6e",
  null
  
)

export default component.exports